import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ds-service-unavailable',
  templateUrl: './service-unavailable.component.html',
  styleUrls: ['./service-unavailable.component.scss']
})
export class ServiceUnavailableComponent implements OnInit {

  constructor() {
    document.body.classList.add("background-gray");
  }

  ngOnInit(): void {
  }

}
